import React from 'react';
import clsx from 'clsx';
import { ProfileUsername } from '../../HistoryDetails/ProfileUsername/ProfileUsername.tsx';
import styles from './OpponentsCell.module.scss';
export const OpponentsCell = ({ players, wrap, onUsernameClick })=>/*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.opponents, wrap && styles.wrap)
    }, players.map((player)=>/*#__PURE__*/ React.createElement(ProfileUsername, {
            key: player.rank,
            username: player.username,
            hasProfile: player.hasProfile,
            onUsernameClick: onUsernameClick
        })));
